import { apyToApr } from '../../../utils/parsing'
import { YieldFetcher, YieldResult } from '../../types'

const WEETH_URL = 'https://www.ether.fi/api/apr'
const WEETHS_URL =
  'https://api.sevenseas.capital/etherfi/ethereum/performance/0x917ceE801a67f933F2e6b33fC0cD1ED2d5909D88'
const weeths = 'Super Symbiotic LRT::weETHs'

/**
 * eBTC — ether.fi's Bitcoin LRT (Veda BoringVault). Same SevenSeas
 * performance endpoint as weETHs, keyed by the eBTC vault address. The
 * `apy` field is a fraction; `apyToApr(...) * 100` matches the percent
 * convention. Returns 0 until restaking rewards start flowing.
 */
const EBTC_URL =
  'https://api.sevenseas.capital/etherfi/ethereum/performance/0x657e8C867D8B37dCC18fA4Caead9C45EB088C642'

/**
 * weeth depends on the wsteth result.
 * The orchestrator passes wstethPromise via createWeethFetcher.
 */
export const createWeethFetcher = (
  wstethPromise: Promise<YieldResult | undefined>,
): YieldFetcher => ({
  label: 'WEETH',
  fetch: async () => {
    const wstethRes = await wstethPromise
    const wstethVal = wstethRes?.WSTETH ?? 0
    let aYield = 0
    try {
      const weethRes = await fetch(WEETH_URL).then((r) => r.json())
      aYield = Number(weethRes.lrt2Apr)
    } catch (e) {
      aYield = 0.5
    }
    return { WEETH: aYield + wstethVal }
  },
})

export const weethsFetcher: YieldFetcher = {
  label: 'WEETHS',
  fetch: async () => {
    const res = await fetch(WEETHS_URL).then((r) => r.json())
    return { [weeths]: apyToApr(res.Response.apy) * 100 }
  },
}

export const ebtcFetcher: YieldFetcher = {
  label: 'EBTC',
  fetch: async () => {
    const res = await fetch(EBTC_URL).then((r) => r.json())
    // Canonical token-list assetGroup (see stcelo.ts) — drives the lending join.
    return {
      'Ether fi Staked BTC::EBTC':
        apyToApr(Number(res?.Response?.apy) || 0) * 100,
    }
  },
}
